import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { UIState } from './types';

const initialState: UIState = {
  showSidebar: false,
  showAviatrixPopup: false,
  isErrorPage: false,
  shouldShowRegistrationBonus: true,
  showTabletSportSidebar: true,
};

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar(state, action: PayloadAction<boolean>) {
      return {
        ...state,
        showSidebar: action.payload,
      };
    },
    setShouldShowRegistrationBonus(state, action: PayloadAction<boolean>) {
      return {
        ...state,
        shouldShowRegistrationBonus: action.payload,
      };
    },
    toggleAviatrixPopup(state, action: PayloadAction<boolean>) {
      return {
        ...state,
        showAviatrixPopup: action.payload,
      };
    },
    setShowTabletSportSidebar(state, action: PayloadAction<boolean>) {
      return {
        ...state,
        showTabletSportSidebar: action.payload,
      };
    },
  },
});

export const { toggleSidebar, setShouldShowRegistrationBonus, toggleAviatrixPopup, setShowTabletSportSidebar } =
  uiSlice.actions;
